import { useEffect } from 'react';
import { Table } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { isMobile } from '../../../../../../services/clientService';
import { getTableColumns } from './constants';
import { fetchEntitites } from '../../../../../../reducers/Entities/actions';
import { postRequest } from '../../../../../../services/requestService';
import { showErrorToast } from '../../../../../../services/notificationsService';

export const EntitiesTable = () => {
  const dispatch = useDispatch();
  const { entities, isFetchingEntities } = useSelector(
    ({ EntitiesReducer }) => EntitiesReducer,
  );
  const tableScroll = {
    scrollToFirstRowOnChange: true,
    x: isMobile() ? true : '',
  };

  const pagination = {
    position: ['bottomRight'],
    defaultPageSize: 10,
  };

  useEffect(() => {
    dispatch(fetchEntitites());
  }, []);

  const deleteEntity = async (entityName) => {
    try {
      await postRequest('/buyers/entities/delete-entity', {
        entityName,
      });
      dispatch(fetchEntitites());
    } catch (error) {
      showErrorToast(error.response?.data?.reason || 'Deleting entity failed!');
    }
  };

  return (
    <Table
      rowKey="name"
      loading={isFetchingEntities}
      columns={getTableColumns(deleteEntity)}
      dataSource={entities}
      scroll={tableScroll}
      pagination={pagination}
    />
  );
};
